import React, { Component } from 'react';
import { Image } from 'antd';
import './index.scss';
import { DEVICE_DETACTION } from '../../utils/device';

class TemplateList extends Component {
    constructor (props) {
        super(props);
    }

    render () {
        return (
            <div className='template-list'>
                {this.props.children}
                {[0,1,2,3,4,5,6,7,8,9].map((index)=>{
                    return <div className='template-info-empty' key={index} aria-hidden="true"></div>
                })}
            </div>
        )
    }
}

class TemplateListItem extends Component {
    constructor (props) {
        super(props);
    }

    // Prevent image drag in Firefox
    onDragStart = (e) => {
        e.stopPropagation();
        e.preventDefault();
    }

    // Enter key handler
    onKeyDown = (e) => {
        if (e.keyCode == 13 || e.keyCode == 32) {
            e.stopPropagation();
            e.preventDefault();
            this.props.onClick();
        }
    }

    render () {
        const { mobile, ios, android, iphone, ipad, touch } = DEVICE_DETACTION;
        let tabIndex = 0;
        if (touch || mobile || ios || android || iphone || ipad) {
            tabIndex = null;
        }
        return (
            <div className={`template-info ${this.props.className||''}`} style={this.props.style} tabIndex={tabIndex} onKeyDown={this.onKeyDown} onClick={this.props.onClick} role="button" aria-label={this.props.name}>
                <div className='template-image-wrapper'>
                    <Image className="template-image" preview={false} src={this.props.src} onDragStart={this.onDragStart} alt="" />
                </div>
                <div className='template-name'>{this.props.name}</div>
            </div>
        )
    }
}

export { TemplateList, TemplateListItem };
